class HTC {
	constructor(country_selector, phone_number, extra_content, content_holder, call_to_action) {
		console.log('this is HTC constructor');
		this.cs = document.querySelector(country_selector);
		this.pn = document.querySelector(phone_number);
		this.ec = document.querySelector(extra_content);
		this.ch = document.querySelector(content_holder);
		this.ca = document.querySelector(call_to_action);
		this.last_tracked = '';
		this.prefixes = ['+', '00'];
		this.country_code = '';
		this.changeCountry();
		this.keyUpPhone();
	}

	changeCountry() {
		this.cs.addEventListener('change', () => {
			let phone_number = this.pn.value;
			if (phone_number.length > 5) {
				this.ch.style.display = 'block';
				this.showFormatedPN();
			}
		});
	}

	keyUpPhone() {
		this.pn.addEventListener('keyup', () => {
			let phone_number = this.pn.value;
			this.pn.value = HTC.sanitizePN(phone_number);
			if (phone_number.length > 5 && this.getCountryCode() !== '') {
				this.ch.style.display = 'block';
				this.showFormatedPN();
			}
		});
	}

	/**
	 * Displays the formatted phone number. Replaces unaccepted characters. Calls phoneFormat to get the right formatting/spacing
	 */

	showFormatedPN() {
		let country_code = '';
		let phone = this.pn.value.replace(/[^0-9\-+]/g, '');
		let html = '';
		let country_placeholder = document.querySelector('.country_name');
		if (country_placeholder) {
			country_placeholder.innerHTML = this.getCountryName();
		}
		for (let i = 0;i < this.prefixes.length;i++) {
			country_code = this.prefixes[i] + ' ' + this.getCountryCode();
			html += '<div class="row"><div class="col-md-2"></div><div class="col-md-8 text-center"><div class="row">';
			html += `<div class='col-6 bg-white py-10 pn-holder'><strong class='fs-20'>${country_code}</strong></div>`;
			html += `<div class='col-6 py-10 pn-holder text-truncate bg-white'><strong class='fs-20'>${this.phoneFormat(phone)}</strong></div>`;
			html += `${HTC.getPhoneNumberDescription()}</div></div><div class='col-md-2'></div></div>`;
			if (i !== this.prefixes.length - 1) {
				html += HTC.getSeparatorHtml();
			}
		}
		this.ec.innerHTML = html;
		this.ca.href = s.url('/buy/voice', {'destination' : this.getCountryName()});

		if (this.last_tracked !== this.getCountryName()) {
			s.track.dataLayerPush({
				'event': 'htc_event',
				'htc_destination': this.getCountryName()
			});
			/* GTM Remarketing Tag */
			s.track.dataLayerPush({
				'event': 'gtm_remarketing',
				'destination': this.getCountryName(),
				'dynx_pagetype': 'other'
			});
			this.last_tracked = this.getCountryName();
		}
	}

	static getSeparatorHtml() {
		return `<div class='my-20'><div class='row'><div class='col-md-12 text-center'><hr><span class='d-inline-block bg-grey-light' style='position:absolute; top: 0'>${s.it('OR')}</span></div></div></div>`;
	}

	getCountryCode() {
		return this.cs.options[this.cs.selectedIndex].value;
	}

	getCountryName() {
		return this.cs.options[this.cs.selectedIndex].dataset.countryName;
	}

	static getPhoneNumberDescription() {
		return `<div class='col-6'>${s.it('COUNTRY_CODE')}</div><div class='col-6'>${s.it('PHONE_NUMBER:')}</div>`;
	}

	static sanitizePN(string) {
		return string.replace(/\D/g, '');
	}

	phoneFormat(phone) {
		let country_code = this.getCountryCode();
		let regex = new RegExp('^([^1-9]+(' + country_code + ')?)|[^0-9]', 'g');
		phone = phone.replace(regex, '');
		phone = phone.replace(/^0+/, '');

		return phone.substr(0, 3) + ' ' + phone.substr(3, 3) + ' ' + phone.substr(6, 4) + ' ' + phone.substr(10, 4);
	}
}
